// second representations of time
// todo: get a library for months, leap years, etc.
export const YEAR_SECS = 31536000; // not leap year
export const MONTH_SECS = 2628000; // rough estimate
export const WEEK_SECS = 604800;
export const DAY_SECS = 86400;
export const HR_SECS = 3600;
export const MIN_SECS = 60;
